import React from 'react';

// Real social proof — clients and creator/executive voices Freddy Media has worked with.
const PROOF = [
  { name: 'Zapier' },
  { name: 'George Saliba' },
  { name: 'PE Guy' },
  { name: 'Chris Koerner' },
];

export default function LogoMarquee() {
  return (
    <section className="py-12 sm:py-16 border-y border-white/5 bg-[#0B1138]" data-testid="logo-marquee-section" aria-label="Brands and voices we have worked with">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <p className="text-[10px] sm:text-xs font-mono uppercase tracking-[0.3em] text-[#6B7280] mb-8">
          ★ We&apos;ve worked with ★
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-10 sm:gap-x-16 gap-y-6">
          {PROOF.map((p, i) => (
            <div key={i} className="flex items-center" data-testid={`proof-item-${i}`}>
              {p.logo ? (
                <img src={p.logo} alt={p.name} className="h-7 sm:h-8 w-auto opacity-70 hover:opacity-100 transition-opacity"
                  style={{ filter: 'brightness(0) invert(1)' }} loading="lazy" />
              ) : (
                <span className="font-display text-lg sm:text-xl font-bold text-white/70 hover:text-white transition-colors tracking-tight">
                  {p.name}
                </span>
              )}
            </div>
          ))}
          <div className="flex items-center" data-testid="proof-item-execs">
            <span className="text-xs sm:text-sm font-mono uppercase tracking-wider text-[#FF4343]">
              + hundreds of executives
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
